import { isBefore, startOfDay } from "date-fns";
import { toTZDate } from "@/utils/dates/dateFormats";
import { getWorksheetEditingPolicy } from "@/utils/dates/get-worksheet-editing-policy";

export function isWorksheetDateWithinEditingWindow(
  worksheetDate: Date,
  minDate: Date = getWorksheetEditingPolicy().minDate
): boolean {
  const normalizedWorksheetDate = startOfDay(toTZDate(new Date(worksheetDate)));
  const normalizedMinDate = startOfDay(minDate);

  return !isBefore(normalizedWorksheetDate, normalizedMinDate);
}
